import { render, staticRenderFns } from "./NostoPage.vue?vue&type=template&id=15f0dffb&"
import script from "./NostoPage.vue?vue&type=script&lang=ts&"
export * from "./NostoPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports